import { extend, get, set, bind, unbind } from 'omi/src/extend'
const BINDING_HANDLERS = []

const addBindingHandler = handler => {
    BINDING_HANDLERS.push(handler)
}
const isChangeOnUpdate = el => {
    if (el.hasAttribute('change-on-update')) {
        let val = el.getAttribute('change-on-update')
        return val === true || val === '1' || val === 'true'
    }
    return true
}
const selectUpdate = (el, path, scope) => {
    let val = get(scope, path)
    if (val === false || val === null || val === undefined) {
        val = ''
    } else {
        el.value = val.toString()
    }
}
const selectModelHandler = (el, path, scope) => {
    if (el.nodeName === 'SELECT') {
        unbind(el, 'change')
        bind(el, 'change', () => {
            set(scope, path, el.value)
        })
        selectUpdate(el, path, scope)
        return el.nodeName
    }
}
addBindingHandler(selectModelHandler)

const radioUpdate = (el, path, scope) => {
    el.checked = get(scope, path) === el.value
}
const radioModelHandler = (el, path, scope) => {
    if (el.type === 'radio' && el.nodeName == 'INPUT') {
        unbind(el, 'change')
        bind(el, 'change', () => {
            set(scope, path, el.value)
        })
        radioUpdate(el, path, scope)
        return el.type
    }
}
addBindingHandler(radioModelHandler)

const checkboxUpdate = (el, path, scope) => {
    let value = get(scope, path)
    if (value instanceof Array) {
        el.checked = value.indexOf(el.value) != -1
    } else {
        el.checked = value === tureVal
    }
}
const checkboxModelHandler = (el, path, scope) => {
    if (el.type === 'checkbox' && el.nodeName == 'INPUT') {
        const tureVal = el.getAttribute('o-true-value') || true
        const falseVal = el.getAttribute('o-false-value') || false
        unbind(el, 'change')
        bind(el, 'change', () => {
            let value = get(scope, path)
            if (value instanceof Array) {
                let valSet = new Set(value)
                if (el.checked) {
                    valSet.add(el.value)
                } else {
                    valSet.delete(el.value)
                }
                value.splice(0, value.length, ...valSet)
            } else {
                set(scope, path, el.checked ? tureVal : falseVal)
            }
        })
        checkboxUpdate(el, path, scope)
        return el.type
    }
}
addBindingHandler(checkboxModelHandler)
//input

const inputUpdate = (el, path, scope) => {
    el.value = get(scope, path) || ''
    checkRequired(el)
}
const checkRequired = (el) => {
    if (el.required) {
        if (el.value == '') {
            el.classList.remove('required-valid')
        } else {
            el.classList.add('required-valid')
        }
    }
}
addBindingHandler((el, path, scope) => {
    if (el.nodeName == 'INPUT') {
        let filter = el.getAttribute('filter')
        if (filter) {
            let reg = new RegExp(filter)
            unbind(el, 'keypress')
            //过滤输入字符
            bind(el, 'keypress', evt => {
                if (!reg.test(evt.key)) {
                    evt.preventDefault()
                }
            })
        }

        unbind(el, 'input')
        bind(el, 'input', evt => {
            set(scope, path, el.value)
            checkRequired(el)
        })
        inputUpdate(el, path, scope)
        return el.nodeName
    }
})
extend('model', (el, path, scope) => {
    let raw = scope
    scope = scope.bindingScope ?? scope.props?.bindingScope ?? scope
    if (scope === false) {
        raw = scope = window
    }


    let bindings = raw.__bindings ?? (raw.__bindings = [])

    for (let handler of BINDING_HANDLERS) {
        if (typeof handler(el, path, scope) == 'string') {
            bindings.push({
                element: el,
                path,
                handler
            })
            break
        }
    }

    if (!raw.hasOwnProperty('updateBindings')) {
        raw.updateBindings = () => {
            for (let binding of bindings) {
                binding.handler(binding.element, binding.path, scope)
            }
        }
    }



    // if (typeof updateAction == 'function' && isChangeOnUpdate(el)) {
    //     if (!scope.__updated) {
    //         scope.__updateActions = []
    //         scope.__updated = scope.updated
    //         scope.updated = () => {
    //             scope.__updated()
    //             for (let action of scope.__updateActions) {
    //                 action()
    //                 // //增強輸入校驗
    //                 // if (scope.customValidity) {
    //                 //   setOrAdd(scope.customValidity, path, {
    //                 //     element: el,
    //                 //     validity: el.validity
    //                 //   })
    //                 // }
    //             }
    //         }
    //     }
    //     scope.__updateActions.push(updateAction)
    // }

    //增強輸入校驗
    // if (scope.customValidity) {
    //   setOrAdd(scope.customValidity, path, {
    //     element: el,
    //     validity: el.validity
    //   })
    // }
})
